import $ from 'jquery';
import Thumbnail from './thumbnail';
import tabParams from '../tab_params';
import { defaultConfig, defaultState } from './default_settings';
import ImageCalculator from './image_calculator';

function ThumbBoard(data, $ctx, config, appState) {
  const conf = $.extend({}, defaultConfig, config);

  this.config = conf;

  this.thumbnails = [];
  this.data = data;
  this.appState = appState;

  this.$ctx = $ctx;

  this.$areaWrapper = $ctx.find(conf.areaWrapper);
  this.$board = $ctx.find(conf.board);

  this.state = defaultState;
}

ThumbBoard.prototype = {
  /**
   * setBodyWidthByBrowser
   * 이미지가 그려질 영역의 width값을 셋팅하는 메소드
   */
  setBoardWidth() {
    // [PC개편] 탭의 이미지가 그려질 가로사이즈를 마진을 포함하여 계산.
    // 배열계산로직에 여백이 3px 정도 들어가 있다. 따라서 (그려질 구역의 마진 * 2(양쪽) - 3px)
    this.state.boardWidth = this.$ctx.width() - (this.$areaWrapper.get(0).offsetLeft * 2 - 3);
    this.$board.css('width', this.state.boardWidth + "px");
  },
  /**
   * setImageDiv
   * 1줄에 들어갈 이미지의 개수를 정하는 메소드
   * 해당 메소드에서 1줄당 이미지 개수 컷팅을 해서
   * mathImageDiv 메소드로 보내 1줄마다의 이미지들에 대한 resizing을 완성한다.
   */
  setImageDiv() {
    /* this.body 의 width를 재조정. */
    this.setBoardWidth();
    ImageCalculator(this.config)(this.appState, this.state, this.data);
  },

  loadImages(thumbs) {
    $.each(thumbs, (idx, thumb) => {
      if (!thumb.imageLoaded) {
        thumb.startImageLoad();
      }
    });
  },

  updateData(newData, callback) {
    const startIdx = this.data.length;
    this.data = this.data.concat(newData);
    this.setImageDiv();
    if (typeof callback === 'function') {
      callback(startIdx);
    }
  },

  insertElement($elementHTML, idx) {
    if ($elementHTML) {
      $elementHTML.insertAfter(this.thumbnails[idx].$html);
    }
  },

  _makeThumbnailHTMLElements(startIdx) {
    const frag = document.createDocumentFragment();
    const thumbs = $.map(this.data, (data, idx) => {
      if (idx < startIdx) {
        return null;
      }
      return new Thumbnail({ data }, this.$board, tabParams, idx);
    });
    this.thumbnails = this.thumbnails.concat(thumbs);

    $.each(thumbs, (idx, thumbnail) => {
      const thumb = thumbnail.render();
      frag.appendChild(thumb);
    });
    return frag;
  },

  renderImages(startIdx = 0) {
    const newImages = this._makeThumbnailHTMLElements(startIdx);
    this.$board.get(0).appendChild(newImages);
    this.loadImages(this.thumbnails);
    this.appState.preventAjaxCall = false;
    this.$ctx.trigger('render');
  },

  resizeImages() {
    $.each(this.data, (idx, each) => {
      const thumb = this.thumbnails[idx];
      thumb.$html.css({
        width: Math.floor(each.dw) +'px',
        height: each.dh + 'px',
        marginRight: '',
        display: each.hide === 'Y' ? 'none' : 'block'
      });
      thumb.$img.css($.extend({
        width: each.iw + 'px',
        height: each.ih + 'px'
      }, each.css));
      thumb.$a.css({
        width: `${Math.floor(each.dw) - 2}px`,
        height: `${each.dh - 2}px`
      });
    });
    this.$ctx.trigger({type: 'thumb:resize'});
  },

  init() {
    this.setImageDiv();
    this.renderImages();
    this.$ctx.trigger('init');
  }
};

export default ThumbBoard;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/thumb_board/thumb_board.js
 **/